import { CheckBox, SelectBox, Validator } from "devextreme-react";
import { RequiredRule } from "devextreme-react/form";
import { useDispatch } from "react-redux";
import { updateInvRecip, updateRole } from "./Redux/sponsorInfo";
import { useEffect, useState } from "react";
import axios from "axios";
import DataSource from "devextreme/data/data_source";

export default function RoleComponent(props) {
  const { sponsorInfo } = props;

  const [roleDataSource, setRoleDataSource] = useState(null);

  const dispatch = useDispatch();

  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/sprInfo/role`
    );

    setRoleDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "role",
        },
      })
    );
  }, []);

  const onRoleValueChanged = (e) => {
    dispatch(
      updateRole({
        role: e.value,
      })
    );
  };

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      role: args.text,
    };

    args.customItem = roleDataSource
      .store()
      .insert(newItem)
      .then(() => roleDataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  };

  const onInvRecipValueChanged = (e) => {
    dispatch(
      updateInvRecip({
        invRecip: e.value ? e.value : false,
      })
    );
  };

  return (
    <>
      <SelectBox
        dataSource={roleDataSource}
        displayExpr={"role"}
        valueExpr={"role"}
        acceptCustomValue={true}
        value={sponsorInfo.role}
        showClearButton={true}
        style={{
          float: "left",
          width: "45%",
          marginRight: "3px",
        }}
        onValueChanged={onRoleValueChanged}
        onCustomItemCreating={onCustomItemCreating}
      >
        <Validator validationGroup="sponsorInfoData">
          <RequiredRule message={"Role is required."} />
        </Validator>
      </SelectBox>
      <CheckBox
        value={sponsorInfo.invRecip}
        text="Invoice Recipient"
        style={{
          marginLeft: "10px",
          marginTop: "10px",
        }}
        onValueChanged={onInvRecipValueChanged}
      />
    </>
  );
}
